import React, { useMemo, useState } from 'react';

import Birthdays from './Birthdays';
import WorkAnniversary from './WorkAnniversary';
import LatestHiring from './LatestHiring';
import { filterAndSortCelebrations } from '../utils/celebrationWindow';

const TABS = {
  birthdays: 'birthdays',
  anniversaries: 'anniversaries',
  hiring: 'hiring'
};

const UpcomingCelebrationsTabs = ({
  birthdayList = [],
  workAnniversaryList = [],
  latestHiringList = []
}) => {
  const [activeTab, setActiveTab] = useState(TABS.birthdays);

  const birthdayCount = useMemo(
    () => filterAndSortCelebrations(birthdayList, 'dateOfBirth').length,
    [birthdayList]
  );
  const anniversaryCount = useMemo(
    () => filterAndSortCelebrations(workAnniversaryList, 'dateOfJoining').length,
    [workAnniversaryList]
  );
  const hiringCount = latestHiringList.length;

  return (
    <div className="card dashboard-celebrations-tabs h-100">
      <div className="card-header dashboard-celebrations-tabs__header border-0 bg-transparent">
        <div
          className="dashboard-celebrations-tabs__segment dashboard-celebrations-tabs__segment--three"
          role="tablist"
          aria-label="Birthdays, work anniversaries, and recent hiring"
        >
          <button
            type="button"
            role="tab"
            id="tab-celebrations-birthdays"
            aria-selected={activeTab === TABS.birthdays}
            aria-controls="panel-celebrations-birthdays"
            className="dashboard-celebrations-tabs__tab"
            onClick={() => setActiveTab(TABS.birthdays)}
          >
            <i className="icofont icofont-gift d-none d-sm-inline" aria-hidden />
            <span className="dashboard-celebrations-tabs__tab-text">Birthdays</span>
            {birthdayCount > 0 ? (
              <span className="dashboard-celebrations-tabs__count">{birthdayCount}</span>
            ) : null}
          </button>
          <button
            type="button"
            role="tab"
            id="tab-celebrations-anniversaries"
            aria-selected={activeTab === TABS.anniversaries}
            aria-controls="panel-celebrations-anniversaries"
            className="dashboard-celebrations-tabs__tab"
            onClick={() => setActiveTab(TABS.anniversaries)}
          >
            <i className="icofont icofont-trophy-alt d-none d-sm-inline" aria-hidden />
            <span className="dashboard-celebrations-tabs__tab-text">Anniversaries</span>
            {anniversaryCount > 0 ? (
              <span className="dashboard-celebrations-tabs__count">{anniversaryCount}</span>
            ) : null}
          </button>
          <button
            type="button"
            role="tab"
            id="tab-celebrations-hiring"
            aria-selected={activeTab === TABS.hiring}
            aria-controls="panel-celebrations-hiring"
            className="dashboard-celebrations-tabs__tab"
            onClick={() => setActiveTab(TABS.hiring)}
          >
            <i className="icofont icofont-users-social d-none d-sm-inline" aria-hidden />
            <span className="dashboard-celebrations-tabs__tab-text">Recent hiring</span>
            {hiringCount > 0 ? (
              <span className="dashboard-celebrations-tabs__count">{hiringCount}</span>
            ) : null}
          </button>
        </div>
      </div>

      <div className="card-body px-3 dashboard-celebrations-tabs__body">
        <div
          id="panel-celebrations-birthdays"
          role="tabpanel"
          aria-labelledby="tab-celebrations-birthdays"
          hidden={activeTab !== TABS.birthdays}
        >
          {activeTab === TABS.birthdays ? <Birthdays birthdayList={birthdayList} embedded /> : null}
        </div>
        <div
          id="panel-celebrations-anniversaries"
          role="tabpanel"
          aria-labelledby="tab-celebrations-anniversaries"
          hidden={activeTab !== TABS.anniversaries}
        >
          {activeTab === TABS.anniversaries ? (
            <WorkAnniversary workAnniversaryList={workAnniversaryList} embedded />
          ) : null}
        </div>
        <div
          id="panel-celebrations-hiring"
          role="tabpanel"
          aria-labelledby="tab-celebrations-hiring"
          hidden={activeTab !== TABS.hiring}
        >
          {activeTab === TABS.hiring ? (
            <LatestHiring latestHiringList={latestHiringList} embedded />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default UpcomingCelebrationsTabs;
